import request from '@/Utils/request.js';
//创建答题记录
export function CreateAnswerRecord (params) {
    return request({
      url: '/api/ExamMusicTheory/CreateAnswerRecord',
      method: 'get',
      params: params
    });
}

//创建答题记录
export function StartExam (params) {
    return request({
      url: '/api/ExamMusicTheory/StartExam',
      method: 'post',
      params: params
    });
}

//提交答题记录
export function SubAnswers(data){
    return request({
        url:'/api/ExamMusicTheory/SubAnswers',
        method:'post',
        data:data
    })
}